export default [
    {
        value: 'messenger',
    }
]